import React, { useState, useEffect } from 'react';
import { Sector } from 'recharts';
import Loading from './components/Loading/Loading';
import { usePortfolioData } from './hooks/usePortfolioData';
import CryptoPieChart from './components/CryptoPieChart';
import DateSwitcher from './components/DateSwitcher';
import CryptoCardsList from './components/CryptoCardsList';
import HamsterAnimation from './components/HamsterAnimation';

const CryptoPortfolio = () => {
  const {
		loading,
		error,
		nearestData,
		yesterdayData,
		twoDaysAgoData,
		windowWidth,
	} = usePortfolioData()
	const [currentView, setCurrentView] = useState('today')
	const [activeIndex, setActiveIndex] = useState(null)
	const [colorMap, setColorMap] = useState({})

	useEffect(() => {
		if (nearestData && nearestData.value) {
			const todayData = JSON.parse(nearestData.value)
			const newColorMap = {}
			todayData.forEach((crypto, index) => {
				newColorMap[crypto.symbol] = `hsl(${
					(index * 360) / todayData.length
				}, 70%, 50%)`
			})
			setColorMap(newColorMap)
		}
	}, [nearestData])

	const getChartData = () => {
		const data = {
			today: nearestData,
			yesterday: yesterdayData,
			twoDaysAgo: twoDaysAgoData,
		}

		const dataList =
			data[currentView] && data[currentView].value
				? JSON.parse(data[currentView].value)
				: []
		return dataList.map((crypto, index) => {
			const existingColor = colorMap[crypto.symbol]
			if (existingColor) {
				return {
					name: crypto.symbol,
					value: crypto.allocation,
					color: existingColor,
				}
			} else {
				const newColor = `hsl(${(index * 360) / dataList.length}, 70%, 50%)`
				return {
					name: crypto.symbol,
					value: crypto.allocation,
					color: newColor,
				}
			}
		})
	}
	const getTableData = () => {
		const data = {
			today: nearestData,
			yesterday: yesterdayData,
			twoDaysAgo: twoDaysAgoData,
		}
		return data[currentView] && data[currentView].value
			? JSON.parse(data[currentView].value)
			: []
	}

	const handlePieClick = (data, index) => {
		setActiveIndex(activeIndex === index ? null : index)
	}

	const renderActiveShape = props => {
		const {
			cx,
			cy,
			innerRadius,
			outerRadius,
			startAngle,
			endAngle,
			fill,
			payload,
		} = props
		return (
			<g>
				<text
					x={cx}
					y={cy}
					dy={8}
					textAnchor='middle'
					fill='#fff'
					fontSize='16'
					fontWeight='bold'
				>
					{payload.name} {payload.value}%
				</text>
				<Sector
					cx={cx}
					cy={cy}
					innerRadius={innerRadius}
					outerRadius={outerRadius}
					startAngle={startAngle}
					endAngle={endAngle}
					fill={fill}
				/>
				<Sector
					cx={cx}
					cy={cy}
					startAngle={startAngle}
					endAngle={endAngle}
					innerRadius={outerRadius + 6}
					outerRadius={outerRadius + 10}
					fill={fill}
				/>
			</g>
		)
	}

	return (
		<div className='chart'>
			<h1>
				<span>After-Tomorrow </span> Crypto Portfolio{' '}
			</h1>
			<HamsterAnimation />
			<DateSwitcher currentView={currentView} setCurrentView={setCurrentView} />
			{loading ? (
				<Loading />
			) : getChartData().length > 0 ? (
				<>
					<h2>
						{currentView === 'twoDaysAgo'
							? 'Two Days Ago'
							: currentView.charAt(0).toUpperCase() + currentView.slice(1)}
					</h2>
					<CryptoPieChart
						data={getChartData()}
						windowWidth={windowWidth}
						activeIndex={activeIndex}
						handlePieClick={handlePieClick}
						renderActiveShape={renderActiveShape}
					/>
					<CryptoCardsList
						tableData={getTableData()}
						chartData={getChartData()}
						activeIndex={activeIndex}
					/>
				</>
			) : (
				<div>No data available for the selected day.</div>
			)}
			{error && <div className='error-message'>{error}</div>}
		</div>
	)
};

export default CryptoPortfolio;
